import { useEffect, useId, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { membersAPI, authAPI } from '../services/api';
import { getNavigationForRole, navigationByRole } from './navigation';

const iconPaths = {
  dashboard: 'M3 13.5 12 4l9 9M5.25 11.25V20h13.5v-8.75',
  members: 'M16 11a4 4 0 1 0-8 0 4 4 0 0 0 8 0ZM3.5 20a6.5 6.5 0 0 1 13 0M18 8a3 3 0 1 1 0 6M18.5 20a5.5 5.5 0 0 0-2.2-4.4',
  deceased: 'M12 8.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 11.5c-3.38 0-6.5 1.69-6.5 4.75v.75h13v-.75c0-3.06-3.12-4.75-6.5-4.75Z',
  beneficiaries: 'M12 21s-6.75-4.35-9-9.3C1.5 7.8 4.2 4.5 8.1 4.5c1.7 0 3 .8 3.9 2 0-.1.1-.1.1-.2.9-1.1 2.2-1.8 3.8-1.8 3.9 0 6.6 3.3 5.1 7.2-2.25 4.95-9 9.3-9 9.3Z',
  payments: 'M3 7.5h18v9H3zM3 10.5h18M7.5 15h3',
  receipt: 'M9 14.25l1.5 1.5 3-3.75M12 3c-4.2 0-7.5 3.3-7.5 7.5S7.8 18 12 18s7.5-3.3 7.5-7.5S16.2 3 12 3zM8.25 7.5h7.5M8.25 10.5h7.5',
  claims: 'M7.5 4.5h9M7.5 8.25h9M6 3h12A1.5 1.5 0 0 1 19.5 4.5v15A1.5 1.5 0 0 1 18 21H6A1.5 1.5 0 0 1 4.5 19.5v-15A1.5 1.5 0 0 1 6 3Zm2.25 10.5 1.5 1.5 3.75-3.75',
  reports: 'M6.75 4.5h10.5A1.5 1.5 0 0 1 18.75 6v12a1.5 1.5 0 0 1-1.5 1.5H6.75A1.5 1.5 0 0 1 5.25 18V6a1.5 1.5 0 0 1 1.5-1.5Zm2.25 3.75h6m-6 3h6m-6 3h3',
  settings: 'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  users: 'M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z',
  system: 'M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z',
};

function NavIcon({ name, className = 'h-5 w-5' }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className}>
      <path strokeLinecap="round" strokeLinejoin="round" d={iconPaths[name]} />
    </svg>
  );
}

function NavItem({ item, mobile = false, onNavigate }) {
  if (mobile) {
    const tile = 'flex min-h-[52px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-2xl px-1 py-1.5 text-[10px] font-semibold active:scale-90 transition-transform duration-150';
    if (item.disabled) {
      return (
        <span className={`${tile} text-white/25`} aria-disabled="true">
          <NavIcon name={item.icon} className="h-5 w-5" />
          <span className="text-center leading-tight">{item.label}</span>
        </span>
      );
    }
    return (
      <NavLink to={item.path} end={item.path === '/'} onClick={onNavigate}
        className={`${tile} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400`}>
        {({ isActive }) => (
          <>
            <span className={`flex h-8 w-8 items-center justify-center rounded-[14px] transition-all duration-200 ${
              isActive ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-[0_4px_12px_rgba(244,121,32,0.5)]' : 'text-white/65'
            }`}>
              <NavIcon name={item.icon} className="h-5 w-5" />
            </span>
            <span className={`text-center leading-tight transition-colors duration-200 ${isActive ? 'text-orange-300' : 'text-white/65'}`}>{item.label}</span>
          </>
        )}
      </NavLink>
    );
  }

  const layout = 'flex min-h-10 items-center gap-3 rounded-xl px-3 py-2 text-[13px]';
  if (item.disabled) return <span className={`${layout} text-slate-400`} aria-disabled="true"><NavIcon name={item.icon} /><span>{item.label}</span></span>;
  return (
    <NavLink to={item.path} end={item.path === '/'} onClick={onNavigate}
      className={({ isActive }) => `${layout} font-medium transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 ${
        isActive
          ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-[0_4px_14px_rgba(244,121,32,0.35)]'
          : 'text-slate-600 hover:translate-x-0.5 hover:bg-orange-50/70 hover:text-orange-700'
      }`}>
      <NavIcon name={item.icon} className="h-[18px] w-[18px] shrink-0" />
      <span className="leading-5">{item.label}</span>
    </NavLink>
  );
}

function groupLinks(links) {
  const groups = new Map();
  for (const item of links) {
    const section = item.section || navigationByRole.admin.find((entry) => entry.path === item.path)?.section || 'My Account';
    if (!groups.has(section)) groups.set(section, []);
    groups.get(section).push(item);
  }
  return [...groups].map(([section, items]) => ({ section, items }));
}

function GroupedNavigation({ links, onNavigate }) {
  const { pathname } = useLocation();
  const id = useId();
  const groups = groupLinks(links);
  const matches = (item) => pathname === item.path || (item.path !== '/' && pathname.startsWith(item.path + '/'));
  const activeSection = groups.find((group) => group.items.some(matches))?.section;
  const [expanded, setExpanded] = useState(activeSection);

  useEffect(() => { setExpanded(activeSection); }, [pathname, activeSection]);

  return groups.map((group, index) => {
    if (group.section === 'Overview') return <div key={group.section} className="mb-2 space-y-0.5 border-b border-slate-100 pb-2">
      {group.items.map((item) => <NavItem key={item.path} item={item} onNavigate={onNavigate} />)}
    </div>;
    const open = expanded === group.section;
    const active = group.items.some(matches);
    const panelId = `${id}-group-${index}`;
    return <div key={group.section}>
      <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setExpanded(open ? null : group.section)}
        className={`flex min-h-11 w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-[13px] font-semibold transition-colors focus-visible:ring-2 focus-visible:ring-orange-500 ${active ? 'bg-orange-50/80 text-orange-700' : 'text-slate-700 hover:bg-slate-50'}`}>
        <NavIcon name={group.section === 'Administration' ? 'settings' : group.items[0].icon} className="h-[18px] w-[18px] shrink-0" />
        <span className="flex-1">{group.section}</span>
        <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`}><path strokeLinecap="round" strokeLinejoin="round" d="m5 7.5 5 5 5-5" /></svg>
      </button>
      {open && <div id={panelId} className={`mb-2 ml-5 space-y-0.5 border-l-2 pl-2 ${active ? 'border-orange-200' : 'border-slate-200'}`}>
        {group.items.map((item) => <NavItem key={item.path} item={item} onNavigate={onNavigate} />)}
      </div>}
    </div>;
  });
}

function MoreGridItem({ item, onNavigate }) {
  if (item.disabled) {
    return (
      <span className="flex flex-col items-center gap-1.5 rounded-2xl p-1.5 text-center text-slate-300" aria-disabled="true">
        <span className="flex h-[52px] w-[52px] items-center justify-center rounded-[18px] bg-gradient-to-br from-[#1b2857] to-[#232f6a] text-white/50">
          <NavIcon name={item.icon} className="h-6 w-6" />
        </span>
        <span className="w-full text-[11px] font-medium leading-tight break-words">{item.label}</span>
      </span>
    );
  }
  return (
    <NavLink to={item.path} end={item.path === '/'} onClick={onNavigate}
      className="flex flex-col items-center gap-1.5 rounded-2xl p-1.5 text-center active:scale-90 transition-transform duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500">
      {({ isActive }) => (
        <>
          <span className={`flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-[18px] transition-all duration-200 ${
            isActive ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-[0_6px_16px_rgba(244,121,32,0.4)]' : 'bg-gradient-to-br from-[#1b2857] to-[#232f6a] text-white shadow-[0_2px_8px_rgba(27,40,87,0.25)]'
          }`}>
            <NavIcon name={item.icon} className="h-6 w-6" />
          </span>
          <span className={`w-full text-[11px] font-medium leading-tight break-words ${isActive ? 'text-orange-700' : 'text-slate-600'}`}>{item.label}</span>
        </>
      )}
    </NavLink>
  );
}

function MoreGridNavigation({ links, onNavigate }) {
  const groups = groupLinks(links);
  return groups.map((group) => (
    <div key={group.section} className="mb-4 last:mb-0">
      <p className="mb-2 pl-1 text-[11px] font-semibold uppercase tracking-wide text-slate-400">{group.section}</p>
      <div className="grid grid-cols-3 gap-x-2 gap-y-4">
        {group.items.map((item) => <MoreGridItem key={item.path} item={item} onNavigate={onNavigate} />)}
      </div>
    </div>
  ));
}

const MAX_VISIBLE = 4;

export function MobileNavBar() {
  const { user } = useAuthStore();
  const links = getNavigationForRole(user?.role, user?.permissions);
  const [moreOpen, setMoreOpen] = useState(false);
  const location = useLocation();
  const moreButton = useRef(null);
  const panel = useRef(null);
  const visibleLinks = links.slice(0, MAX_VISIBLE);
  const moreLinks = links.slice(MAX_VISIBLE);
  const closeMenu = () => { setMoreOpen(false); moreButton.current?.focus(); };

  useEffect(() => { setMoreOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!moreOpen) return;
    panel.current?.querySelector('button')?.focus();
    const onKey = (event) => {
      if (event.key === 'Escape') { event.preventDefault(); closeMenu(); }
      if (event.key === 'Tab') {
        const items = panel.current?.querySelectorAll('a, button');
        if (!items?.length) return;
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [moreOpen]);

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-3 pb-[max(10px,env(safe-area-inset-bottom))] lg:hidden">
      {moreOpen && <div className="fixed inset-0 bg-slate-900/30 backdrop-blur-[1px]" onClick={closeMenu} aria-hidden="true" />}
      <nav aria-label="Mobile navigation" className="relative overflow-hidden rounded-[26px] bg-gradient-to-br from-[#1b2857] to-[#232f6a] shadow-[0_14px_34px_rgba(15,23,42,0.4)] ring-1 ring-white/10">
        <div className="flex items-stretch gap-0.5 px-1.5 py-2">
          {visibleLinks.map((item) => <NavItem key={item.path} item={item} mobile onNavigate={() => setMoreOpen(false)} />)}
          {moreLinks.length > 0 && (() => {
            const moreActive = moreOpen || moreLinks.some((item) => location.pathname === item.path || location.pathname.startsWith(item.path + '/'));
            return (
              <button ref={moreButton} type="button" aria-expanded={moreOpen} aria-controls="mobile-more-navigation" onClick={() => setMoreOpen((value) => !value)}
                className="flex min-h-[52px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-2xl px-1 py-1.5 text-[10px] font-semibold active:scale-90 transition-transform duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400">
                <span className={`flex h-8 w-8 items-center justify-center rounded-[14px] transition-all duration-200 ${
                  moreActive ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-[0_4px_12px_rgba(244,121,32,0.5)]' : 'text-white/65'
                }`}>
                  <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-5 w-5"><path strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" /></svg>
                </span>
                <span className={`text-center leading-tight transition-colors duration-200 ${moreActive ? 'text-orange-300' : 'text-white/65'}`}>More</span>
              </button>
            );
          })()}
        </div>
      </nav>
      {moreOpen && <div ref={panel} id="mobile-more-navigation" role="dialog" aria-modal="true" aria-labelledby="mobile-menu-title"
        className="absolute inset-x-3 bottom-full mb-3 overflow-hidden rounded-[26px] bg-white shadow-[0_20px_45px_rgba(15,23,42,0.35)] ring-1 ring-black/5">
        <div className="flex items-center justify-between bg-gradient-to-br from-[#1b2857] to-[#232f6a] px-4 py-3.5">
          <h2 id="mobile-menu-title" className="text-sm font-semibold text-white">More navigation</h2>
          <button type="button" onClick={closeMenu} aria-label="Close navigation" className="flex h-8 w-8 items-center justify-center rounded-full text-lg text-white/80 transition-colors hover:bg-white/15 hover:text-white">×</button>
        </div>
        <nav aria-label="More navigation" className="max-h-[60dvh] overflow-y-auto p-3.5">
          <MoreGridNavigation links={moreLinks} onNavigate={closeMenu} />
        </nav>
      </div>}
    </div>
  );
}

export default function Sidebar() {
  const { user, syncPermissions } = useAuthStore();
  const links = getNavigationForRole(user?.role, user?.permissions);
  const [memberPicture, setMemberPicture] = useState(null);
  const [rollNo, setRollNo] = useState(null);
  const [petitionNo, setPetitionNo] = useState(null);
  const [isLifeMember, setIsLifeMember] = useState(false);

  const displayName = user?.full_name || user?.name || 'AWTF User';
  const initial     = displayName[0]?.toUpperCase() ?? 'A';

  useEffect(() => {
    if (!user) return;
    if (user.role === 'member') {
      membersAPI.me()
        .then(m => {
          if (m?.picture) setMemberPicture(m.picture);
          if (m?.roll_no) setRollNo(m.roll_no);
          if (m?.petition_no) setPetitionNo(m.petition_no);
          setIsLifeMember(m?.membership_type === 'life');
        })
        .catch(() => {});
    } else {
      authAPI.profile()
        .then(p => {
          if (p?.picture) setMemberPicture(p.picture);
          syncPermissions(p?.permissions || []);
        })
        .catch(() => {});
    }
  }, [user]);

  return (
    <aside className="app-sidebar hidden lg:sticky lg:top-0 lg:flex lg:h-[calc(100dvh-5rem)] lg:w-60 lg:shrink-0 lg:flex-col lg:self-start" aria-label="Sidebar">
      <div className="my-2 ml-3 flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-slate-200/70 bg-white/90 shadow-[0_8px_30px_rgba(15,23,42,0.06)] backdrop-blur-xl">
        <NavLink to="/profile" title={displayName}
          className="flex items-center gap-3 bg-gradient-to-br from-[#1b2857] to-[#232f6a] px-4 py-5 transition-colors hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-orange-500 to-orange-600 text-xl font-bold text-white shadow-md ring-2 ring-white/25">
            {memberPicture ? <img src={memberPicture} alt="" className="h-full w-full object-cover" onError={() => setMemberPicture(null)} /> : initial}
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-[13px] font-bold leading-tight text-white" title={displayName}>{displayName}</p>
            <p className="mt-1 inline-flex items-center gap-1.5 truncate text-[10px] font-medium capitalize text-orange-200/80">
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-orange-400" />
              {isLifeMember ? 'Life Member' : rollNo ? `Roll #${rollNo}` : petitionNo ? `Petition #${petitionNo}` : (user?.role || 'member')}
            </p>
          </div>
          <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4 shrink-0 text-white/50"><path strokeLinecap="round" strokeLinejoin="round" d="m7.5 4.5 5 5.5-5 5.5" /></svg>
        </NavLink>
        <nav aria-label="Main navigation" className="sidebar-nav-scroll min-h-0 flex-1 space-y-1 overflow-y-auto px-2 py-3">
          <GroupedNavigation links={links} />
        </nav>
      </div>
    </aside>
  );
}
